// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"184b5e5c","37":"91f208e7","72":"a625eb38","918":"55694763"}[chunkId] + ".chunk.js";
};